
/* eslint-disable @typescript-eslint/no-shadow */
export namespace MultiSelectGraphTypeV1 {
  export enum MultiSelectGraphTypeV1 {
    HORIZONTAL_BAR = "HORIZONTAL_BAR",
    VERTICAL_BAR = "VERTICAL_BAR",
    LINE = "LINE",
    LINE_AREA = "LINE_AREA",
    NONE = "NONE",
  }

  export interface MultiSelectGraphTypeV1DTO {
    case: string;
  }

  export const fromDTO = (dto: MultiSelectGraphTypeV1DTO): MultiSelectGraphTypeV1 => {
    if (dto === undefined || dto === null) {
      throw new InvalidMultiSelectGraphTypeV1Error(
        `Invalid DTO ${dto} provided for MultiSelectGraphTypeV1.MultiSelectGraphTypeV1`
      );
    }
    switch (dto.case) {
      case "HORIZONTAL_BAR":
        return MultiSelectGraphTypeV1.HORIZONTAL_BAR;
      case "VERTICAL_BAR":
        return MultiSelectGraphTypeV1.VERTICAL_BAR;
      case "LINE":
        return MultiSelectGraphTypeV1.LINE;
      case "LINE_AREA":
        return MultiSelectGraphTypeV1.LINE_AREA;
      case "NONE":
        return MultiSelectGraphTypeV1.NONE;
      default:
        throw new InvalidMultiSelectGraphTypeV1Error(
          `Case ${dto.case} is not valid case of MultiSelectGraphTypeV1.MultiSelectGraphTypeV1`
        );
    }
  };

  export const toDTO = (multiSelectGraphTypeV1: MultiSelectGraphTypeV1): MultiSelectGraphTypeV1DTO => {
    const enumDTO = {
      case: MultiSelectGraphTypeV1[multiSelectGraphTypeV1],
    };
    return enumDTO;
  };
}

export class InvalidMultiSelectGraphTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMultiSelectGraphTypeV1Error";
  }
}
export class InvalidMultiSelectGraphTypeV1HorizontalBarError extends InvalidMultiSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMultiSelectGraphTypeV1HorizontalBarError";
  }
}

export class InvalidMultiSelectGraphTypeV1VerticalBarError extends InvalidMultiSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMultiSelectGraphTypeV1VerticalBarError";
  }
}

export class InvalidMultiSelectGraphTypeV1LineError extends InvalidMultiSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMultiSelectGraphTypeV1LineError";
  }
}

export class InvalidMultiSelectGraphTypeV1LineAreaError extends InvalidMultiSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMultiSelectGraphTypeV1LineAreaError";
  }
}

export class InvalidMultiSelectGraphTypeV1NoneError extends InvalidMultiSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMultiSelectGraphTypeV1NoneError";
  }
}
